import ArticleView from "../utils/ArticleView";

const ArticleContacts = () => {
  return ArticleView("contacts");
};
  
export default ArticleContacts;